<div class="programare-vizita">
    
    <h3>Programeaz&#259;-te</h3>
    
	<p ng-show="createAppointmentCtrl.appointmentCreated">Programarea a fost facuta cu succes. Vei primi &#238;n cur&#226;nd un e-mail şi un SMS. Te rug&#259;m s&#259; urmezi detaliile pentru a confirma programarea.</p>
	
	<form name="appointmentForm" novalidate ng-submit="createAppointmentCtrl.formSubmit(appointmentForm)" ng-show="!createAppointmentCtrl.appointmentCreated">
		
    	<p>Pentru c&#259; &#x219;tim c&#259; timpul t&#259;u este pre&#539;ios, &#238;&#539;i oferim posibilitatea de a-&#539;i programa vizita &#238;n magazin.</p>
		
		<shop-appointment-reasons reasons="createAppointmentCtrl.reasons"></shop-appointment-reasons>
		
	    <div class="row">
	        
	        <div class="col-md-6">
	            
	            <label for="date">Data*</label>
				
				<shop-appointment-date-picker
					ng-if="createAppointmentCtrl.shopAppointmentIntervals.length > 0"
					shop-appointment-intervals="createAppointmentCtrl.shopAppointmentIntervals"
					selected-date="createAppointmentCtrl.appointmentFormModels.date"
					intervals-corresponding-to-the-selected-date="createAppointmentCtrl.intervalsCorrespondingToTheSelectedDate">
				</shop-appointment-date-picker>
				
				<input type="text"
					placeholder="Data program&#259;rii"
					ng-show="createAppointmentCtrl.shopAppointmentIntervals.length === 0"
					ng-disabled="true">
	            
	            <input type="hidden" name="date" ng-model="createAppointmentCtrl.appointmentFormModels.date" ng-required="true">

				<p class="create-appointment-help-block" 
	            	ng-show="createAppointmentCtrl.shopAppointmentIntervals.length === 0">Nu exist&#259; intervale disponibile pentru aceast magazin</p>
	            
	            <div ng-messages="appointmentForm.date.$error" ng-show="appointmentForm.$submitted || appointmentForm.date.$touched">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; data program&#259;rii</p>
	            </div>
	        </div>

	        <div class="col-md-6">
	            <label for="hour">Ora*</label>
	            
	            <select name="hour"
	            	ng-required="true"
	            	ng-model="createAppointmentCtrl.appointmentFormModels.hour"
	            	ng-options="interval as interval.value for interval in createAppointmentCtrl.intervalsCorrespondingToTheSelectedDate"
	            	ng-disabled="createAppointmentCtrl.intervalsCorrespondingToTheSelectedDate.length === 0">
	                <option value="">alege</option>
	            </select>

	            <p class="create-appointment-help-block" 
	            	ng-show="createAppointmentCtrl.appointmentFormModels.date && createAppointmentCtrl.intervalsCorrespondingToTheSelectedDate.length === 0">Nu exist&#259; intervale disponibile pentru aceast&#259; zi</p>
	            
	            <div ng-messages="appointmentForm.hour.$error" ng-show="appointmentForm.$submitted && !(createAppointmentCtrl.appointmentFormModels.date && createAppointmentCtrl.intervalsCorrespondingToTheSelectedDate.length === 0)">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; ora program&#259;rii</p>
	            </div>
	        </div>
	    </div>

	    <div class="row">
	        <div class="col-md-6">
	            <label for="firstName">Prenume*</label>
	            <input type="text" autocomplete="off" name="firstName" placeholder="Prenume" maxlength="50" ng-model="createAppointmentCtrl.appointmentFormModels.firstName" ng-required="true">
	            <div ng-messages="appointmentForm.firstName.$error" ng-show="appointmentForm.$submitted || appointmentForm.firstName.$touched">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; prenumele</p>
	            </div>
	        </div>
	        <div class="col-md-6">
	            <label for="lastName">Nume*</label>
	            <input type="text" autocomplete="off" name="lastName" placeholder="Nume" maxlength="50" ng-model="createAppointmentCtrl.appointmentFormModels.lastName" ng-required="true">
	            <div ng-messages="appointmentForm.lastName.$error" ng-show="appointmentForm.$submitted || appointmentForm.lastName.$touched">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; numele</p>
	            </div>
	        </div>
	    </div>

	    <div class="row">
	        <div class="col-md-6">
	            <label for="email">E-mail*</label>
	            <input type="email" autocomplete="off" name="email" placeholder="email@exemplu.ro" ng-model="createAppointmentCtrl.appointmentFormModels.email" ng-required="true" ng-pattern="/^.+\.[a-zA-Z]{2,10}$/">
	            <div ng-messages="appointmentForm.email.$error" ng-show="appointmentForm.$submitted || appointmentForm.email.$touched">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; adresa de E-mail</p>
	                <p class="create-appointment-help-block" ng-message="email">Formatul adresei de E-mail este invalid</p>
	                <p class="create-appointment-help-block" ng-message="pattern">Formatul adresei de E-mail este invalid</p>
	            </div>
	        </div>
	        <div class="col-md-6">
	            <label for="phoneNo">Nr. telefon mobil*</label>
	            <input type="tel" autocomplete="off" name="phoneNo" placeholder="Nr. de telefon mobil" maxlength="10" ng-model="createAppointmentCtrl.appointmentFormModels.phoneNo" ng-pattern="/^\d{10}$/" ng-required="true">
	            <div ng-messages="appointmentForm.phoneNo.$error" ng-show="appointmentForm.$submitted || appointmentForm.phoneNo.$touched">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; num&#259;rul de telefon mobil</p>
	                <p class="create-appointment-help-block" ng-message="pattern">Num&#259;rul de telefon mobil trebuie sa con&#539;in&#259; zece cifre</p>
	            </div>
	        </div>
	    </div>

	    <div class="row">
	        <div class="col-md-6">
	            <label for="reason">De ce ne vizitezi*</label>
	            <select name="reason" ng-model="createAppointmentCtrl.appointmentFormModels.reason" ng-options="reason as reason.name for reason in createAppointmentCtrl.reasons" ng-required="true">
	                <option value="">alege</option>
	            </select>
	            <div ng-messages="appointmentForm.reason.$error" ng-show="appointmentForm.$submitted || appointmentForm.reason.$touched">
	                <p class="create-appointment-help-block" ng-message="required">Te rug&#259;m completeaz&#259; motivul vizitei</p>
	            </div>
	        </div>
	    </div>

	    <div class="row">
	        <div class="col-md-6">
	            <label class="create-appointment-checkbox-label">
	                <input type="checkbox" name="newsletter" ng-model="createAppointmentCtrl.appointmentFormModels.newsletter">
	                <span>vreau sa m&#259; abonez la newsletter</span>
	            </label>
	            <label class="create-appointment-checkbox-label">
	                <input type="checkbox" name="termsAndCs" ng-model="createAppointmentCtrl.appointmentFormModels.termsAndCs" ng-required="true">
	                <span>sunt de acord cu <a href="https://www.orange.ro/shops/content/termeni_si_conditii.pdf" target="_blank">termenii &#x219;i condi&#539;iile</a></span>
	            </label>
	            <div ng-messages="appointmentForm.termsAndCs.$error" ng-show="appointmentForm.$submitted && appointmentForm.termsAndCs.$invalid">
	                <p class="create-appointment-help-block" ng-message="required">Nu ai bifat c&#259; e&#x219;ti de acord cu "termenii &#x219;i condi&#539;iile"</p>
	            </div>
	        </div>
	    </div>

	    <div class="row">
	        <div class="col-xs-12">
	            <p class="create-appointment-help-block" ng-show="createAppointmentCtrl.submitErrors.tooManyAppointments">Programarea nu s-a efectuat cu succes. Ai incercat s&#259; ob&#539;ii mai mult de dou&#259; program&#259;ri online &#238;n decursul unei s&#259;pt&#259;mani.</p>
	            <p class="create-appointment-help-block" ng-show="createAppointmentCtrl.submitErrors.unavailableInterval">Programarea nu s-a efectuat cu succes. Intervalul orar ales pentru programare nu este liber. Te rug&#259;m s&#259; alegi un alt interval orar.</p>
	            <p class="create-appointment-help-block" ng-show="createAppointmentCtrl.submitErrors.internalServerError">Ne pare r&#259;u, dar programarea ta &#238;n magazin nu a putut fi salvat&#259;. Te rug&#259;m s&#259; revii mai tarziu.</p>
	        </div>
	    </div>

	    <button type="submit" class="btn btn-important create-appointment-btn" ng-disabled="createAppointmentCtrl.formSubmitting" ng-class="{ 'btn-spinner': createAppointmentCtrl.formSubmitting }"><span>Trimite</span></button>
		
		<shop-appointment-form-submitter form-submit="createAppointmentCtrl.formSubmit" form-submitting="createAppointmentCtrl.formSubmitting" submit-errors="createAppointmentCtrl.submitErrors" appointment-created="createAppointmentCtrl.appointmentCreated"></shop-appointment-form-submitter>
	</form>
</div>